import { useTranslation } from "react-i18next";
import { Reveal, MaskedLines } from "@/components/Reveal";

export default function Mentions() {
  const { t } = useTranslation("mentions");
  const sections = t("sections", { returnObjects: true });

  return (
    <div data-testid="mentions-page" className="pt-32 lg:pt-40">
      <header className="mx-auto max-w-7xl px-6 sm:px-8 lg:px-12">
        <p className="overline-label mb-8 flex items-center gap-3">
          <span className="inline-block h-px w-10 bg-brass/60" />
          {t("hero.overline")}
        </p>
        <h1 className="max-w-3xl font-display text-4xl font-light leading-[1.08] tracking-tight text-chalk sm:text-5xl lg:text-6xl">
          <MaskedLines
            lines={[
              t("hero.titleA"),
              <span key="b" className="font-serif italic text-brass">{t("hero.titleB")}</span>,
            ]}
          />
        </h1>
        <p className="mt-8 max-w-2xl text-base leading-relaxed text-mist/85">{t("hero.lead")}</p>
        <p className="mt-4 font-mono text-[10px] uppercase tracking-[0.22em] text-slate2/70">
          {t("hero.updated")}
        </p>
      </header>

      <section className="mx-auto mt-16 max-w-7xl px-6 pb-24 sm:px-8 lg:px-12 lg:mt-20 lg:pb-32">
        <div className="max-w-3xl">
          {sections.map((s, i) => (
            <Reveal key={s.id} delay={i * 0.04}>
              <article
                data-testid={`legal-section-${s.id}`}
                className="border-t border-white/[0.08] py-10 first:border-t-0 first:pt-0"
              >
                <p className="font-mono text-xs tracking-[0.24em] text-brass/70">
                  {String(i + 1).padStart(2, "0")}
                </p>
                <h2 className="mt-3 font-display text-2xl text-chalk">{s.title}</h2>
                <div className="mt-5 space-y-4 text-sm leading-relaxed text-mist/80">
                  {s.paragraphs.map((p, j) => (
                    <p key={j}>{p}</p>
                  ))}
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
